import React, { useEffect, useState } from "react";
import { Modal, Popconfirm, Spin, Table } from "antd";
import { PlusCircle, Sliders } from "react-feather";
import { Link } from "react-router-dom";
import {
  createDepartmentMethod,
  deleteDepartment,
  getAllDepartments,
} from "../../service/ApiServices";
import Swal from "sweetalert2";

const DepartmentGrid = () => {
  const [data, setData] = useState([]);
  const [success, setSuccess] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    departmentName: "",
    HOD: "",
    description: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const roleName = userData?.data.role.roleName;

  useEffect(() => {
    const handler = setTimeout(() => {
      const fetchData = async () => {
        getAllDepartments({ search, setLoading: setLoading2, setData });
      };
      fetchData();
    }, 600);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    if (success) {
      getAllDepartments({ search, setLoading: setLoading2, setData });
      showSuccess("Successfully saved Department!");
      handleCancel();
      handleReset();
    }
    if (isDelete) {
      getAllDepartments({ search, setLoading: setLoading2, setData });
      showSuccess("Successfully deleted Department!");
    }
  }, [success, isDelete]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsEdit(false);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "departmentName",
      key: "departmentName",
    },
    {
      title: "HOD",
      dataIndex: "HOD",
      key: "HOD",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <td className="action-table-data">
          <Link
            className="me-2 p-2"
            to="#"
            onClick={() => {
              setFormData({
                id: record._id,
                HOD: record.HOD,
                departmentName: record.departmentName,
                description: record.description,
              });
              setIsEdit(true);
              setIsModalOpen(true);
            }}
          >
            <i data-feather="download" className="feather-edit"></i>
          </Link>
          {roleName === "Admin" && (
            <Popconfirm
              title="Delete the Department"
              description="Are you sure to delete this Department?"
              onConfirm={() => {
                deleteDepartment({
                  id: record._id,
                  setIsDelete,
                });
              }}
              onCancel={() => {
                console.log("c");
              }}
              okText="Yes"
              cancelText="No"
            >
              <Link className="confirm-text p-2" to="#">
                <i data-feather="trash-2" className="feather-trash-2"></i>
              </Link>
            </Popconfirm>
          )}
        </td>
      ),
    },
  ];
  const handleSubmit = () => {
    if (
      formData.HOD === "" ||
      formData.departmentName === "" ||
      formData.description === ""
    ) {
      alert("Please fill all fields");
      return;
    }
    createDepartmentMethod({
      data: formData,
      setLoading,
      setSuccess,
    });
  };
  const handleReset = () => {
    setFormData({
      id: "",
      departmentName: "",
      HOD: "",
      description: "",
    });
  };

  const showSuccess = (str) => {
    return Swal.fire({
      title: "Good job!",
      text: str,
      icon: "success",
    });
  };
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Departments</h4>
              <h6>Manage your Departments</h6>
            </div>
          </div>
          <div className="page-btn">
            <a className="btn btn-added" onClick={() => setIsModalOpen(true)}>
              <PlusCircle className="me-2" />
              Add New Department
            </a>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <Link className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
                <div className="wordset">
                  <ul>
                    <li>
                      <a
                        href="#"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="pdf"
                      >
                        <img src="assets/img/icons/pdf.svg" alt="pdf" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="excel"
                      >
                        <img src="assets/img/icons/excel.svg" alt="excel" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="print"
                      >
                        <img src="assets/img/icons/printer.svg" alt="print" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="search-set">
                <a href="#" className="btn btn-filter" id="filter_search">
                  <Sliders className="me-2" />
                  Filter
                </a>
              </div>
            </div>
            <div className="table-responsive">
              <Table
                loading={loading2}
                columns={columns}
                dataSource={data}
                rowKey="value"
                pagination={false}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        zIndex={200000}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        closable={false}
      >
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>{isEdit ? "Edit" : "Add"} Department</h4>
                  <p className="mb-0">
                    Fill in the required fields to create an Department
                  </p>
                </div>
              </div>
              <div className="modal-body custom-modal-body">
                <form>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">Department Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.departmentName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              departmentName: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">HOD</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.HOD}
                          onChange={(e) =>
                            setFormData({ ...formData, HOD: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mb-3 summer-description-box">
                        <label className="form-label">Description</label>
                        <div id="summernote" />
                        <input
                          type="text"
                          className="form-control"
                          value={formData.description}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              description: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className=""
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div className="">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                      <button
                        type="button"
                        className="btn btn-submit ml-0"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        {loading ? <Spin size="small" /> : "Save"}
                      </button>
                    </div>

                    <button
                      type="button"
                      className="btn btn-cancel"
                      onClick={() => {
                        handleCancel();
                      }}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DepartmentGrid;
